export const leadGroupsKeys = {
  all: () => ['LEAD_GROUPS'] as const,
  list: ({
    page,
    search,
    limit,
    start,
  }: {
    page: number;
    search: string;
    limit: number;
    start: number;
  }) => ['LEAD_GROUPS', 'list', page, search ?? '', limit, start] as const,
  single_group: (leadGroupId: number) =>
    ['LEAD_GROUPS', 'single', leadGroupId] as const,
};
